import { render, staticRenderFns } from "./booking-settings.vue?vue&type=template&id=65e9a272&"
import script from "./booking-settings.vue?vue&type=script&lang=js&"
export * from "./booking-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports